module.exports = __webpack_public_path__ + "img/big.976ebe9b.jpg";